import BasicApplication from "./Basic.application";

import {
    validationControlCurrentRequest,
} from "../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";



class ExtraVacationDaysApplication extends BasicApplication {
    constructor(options) {
        super(options);
        this.periods = options.periods;
        this.bloodDonationData = {
            donationDate: options.bloodDonationData?.donationDate || null,
            certificateNumber: options.bloodDonationData?.certificateNumber || null,
        };

        this.disabledChildCare = {
            child: options.disabledChildCare?.child || null,
            period: options.disabledChildCare?.period || null,
            isSecondParentWorkCertificateNotRequired:
                options.disabledChildCare?.isSecondParentWorkCertificateNotRequired || false,
            ...(options.disabledChildCare?.secondParentStatus != null && {
                secondParentStatus: options.disabledChildCare.secondParentStatus,
            }),
            ...(options.disabledChildCare?.secondParent != null && {
                secondParent: options.disabledChildCare.secondParent,
            }),
        };

        this.isValid = {
            leaveReasonId: true,
            bloodDonationData: {
                donationDate: true,
                certificateNumber: true,
            },
            disabledChildCare: {
                child: true,
                period: true,
            },
            validDate: true,
        };
    }
    static saveOrUploadValidation(currentRequest, dispatch) {
        if (currentRequest.leaveReasonId !== null) {
            return true;
        } else {
            dispatch(validationControlCurrentRequest("leaveReasonId", false));
            return false;
        }
    }
    static sendToValidation(currentRequest, dispatch, requestAttachments) {
        let isValid = true;
        if(requestAttachments.length > 0 || currentRequest.attachments.length > 0 ) {
            console.log("WORK DOC START", requestAttachments.filter((el) => el.subDocumentTypeName === "DisabilityConfirmation" ));
            if(!requestAttachments.filter((el) => el.subDocumentTypeName === "PlaceResidenceConfirmation" ).length
                // ||
                // !currentRequest.attachments.filter((el) => el.subDocumentTypeName === "PlaceResidenceConfirmation" ).length
            ) {
                dispatch(
                    validationControlCurrentRequest(
                        { object: "disabledChildCare", innerKey: "PlaceResidenceConfirmation" },
                        false,
                        "object",
                    ),
                );
                // isValid = false;

            }
            if(!requestAttachments.filter((el) => el.subDocumentTypeName === "DisabilityConfirmation" ).length
               //  ||
               // !currentRequest.attachments.filter((el) => el.subDocumentTypeName === "DisabilityConfirmation" ).length
            ) {
                dispatch(
                    validationControlCurrentRequest(
                        { object: "disabledChildCare", innerKey: "DisabilityConfirmation" },
                        false,
                        "object",
                    ),
                );
                // isValid = false;

            }
            if(!requestAttachments.filter((el) => el.subDocumentTypeName === "BirthOrGuardianshipCertificate" ).length
                // ||
                // !currentRequest.attachments.filter((el) => el.subDocumentTypeName === "BirthOrGuardianshipCertificate" ).length
            ) {
                dispatch(
                    validationControlCurrentRequest(
                        { object: "disabledChildCare", innerKey: "BirthOrGuardianshipCertificate" },
                        false,
                        "object",
                    ),
                );
                // isValid = false;

            }
        } else {
            dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "BirthOrGuardianshipCertificate" },
                    false,
                    "object",
                ),
            );
            // isValid = false;

            dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "DisabilityConfirmation" },
                    false,
                    "object",
                ),
            );
            // isValid = false;

            dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "PlaceResidenceConfirmation" },
                    false,
                    "object",
                ),
            );
            // isValid = false;

        }


        console.log(currentRequest.disabledChildCare.isSecondParentWorkCertificateNotRequired);
        if (currentRequest.disabledChildCare.isSecondParentWorkCertificateNotRequired) {
            if(!currentRequest.disabledChildCare.secondParentStatus) {
                console.log("start custom validation");
                dispatch(
                    validationControlCurrentRequest(
                        { object: "disabledChildCare", innerKey: "secondParentStatus" },
                        false,
                        "object",
                    ),
                );
                isValid = false;
            } else {
                if(currentRequest.disabledChildCare.secondParentStatus === 2) {
                    if (!currentRequest.disabledChildCare?.secondParent?.pid ) {
                        dispatch(
                            validationControlCurrentRequest(
                                { object: "disabledChildCare", innerKey: "secondParent" },
                                false,
                                "object",
                            ),
                        );
                        isValid = false;
                    }
                } else {
                    // eslint-disable-next-line max-len
                    if(!requestAttachments.filter((el) => el.subDocumentTypeName === "SecondParentEmploymentCertificateNotRequired" ).length
                        // eslint-disable-next-line max-len
                        // !currentRequest.attachments.filter((el) => el.subDocumentTypeName === "SecondParentEmploymentCertificateNotRequired" ).length
                    ) {
                        dispatch(
                            validationControlCurrentRequest(
                                { object: "disabledChildCare", innerKey: "SecondParentEmploymentCertificateNotRequired" },
                                false,
                                "object",
                            ),
                        );
                        // isValid = false;

                    }
                }

            }

        } else {
            console.log(!requestAttachments.filter((el) => el.subDocumentTypeName === "ParentalLeaveAvailable" ).length  );
            console.log(requestAttachments.filter((el) => el.subDocumentTypeName === "ParentalLeaveAvailable" ));
            if(!requestAttachments.filter((el) => el.subDocumentTypeName === "ParentalLeaveAvailable" ).length
                // ||
                // eslint-disable-next-line max-len
                // !currentRequest.attachments.filter((el) => el.subDocumentTypeName === "ParentalLeaveAvailable" ).length
                ) {
                dispatch(
                    validationControlCurrentRequest(
                        { object: "disabledChildCare", innerKey: "ParentalLeaveAvailable" },
                        false,
                        "object",
                    ),
                );
                // isValid = false;

            }
        }

        return isValid;
    }
}

export default ExtraVacationDaysApplication;
